import React from 'react'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import {
  InputLabel,
  InputLabelText,
  LoadingSpinner,
  LoadingIndicator,
} from 'components/generic/Input/styles'
import { Select } from 'components/generic/Input/SelectInput/styles'

const SelectInput = React.forwardRef(
  (
    {
      children,
      label,
      options,
      disabled,
      isValid = true,
      isLoading = false,
      emptyOptionLabel = 'Select',
      ...rest
    },
    ref
  ) => {
    return (
      <InputLabel>
        <InputLabelText>{label || ''}</InputLabelText>
        {isLoading && (
          <LoadingIndicator>
            Loading
            <LoadingSpinner icon={faSpinner} color='gray' spin />
          </LoadingIndicator>
        )}
        <Select isValid={isValid} disabled={disabled || isLoading} {...rest} ref={ref}>
          {!isLoading && (
            <>
              {emptyOptionLabel && <option value=''>{emptyOptionLabel}</option>}
              {options.map(({ id, name }) => (
                <option key={id} value={id}>
                  {name}
                </option>
              ))}
            </>
          )}
        </Select>
      </InputLabel>
    )
  }
)

// Need this to get around false positive lint issue
// see https://github.com/yannickcr/eslint-plugin-react/issues/2269
SelectInput.displayName = 'SelectInput'

export default SelectInput
